import React from 'react';
import { Navigate, RouteObject } from 'react-router-dom';
import MassagerLayout from '@/components/templates/MassagerLayout';
import CheckinListPage from '@/pages/massager/checkin/CheckinListPage';
import CheckinRemarksPage from '@/pages/massager/checkin/CheckinRemarksPage';

/**
 * Authenticated shell for the Massager (checkin) portal.
 * ProtectedMassagerRoute wraps this layer in routes.tsx, so everything rendered
 * here already has a verified session + clinic context available.
 */
export const MassagerRouterLayout: React.FC = () => {
  return <MassagerLayout />;
};

export const massagerRoutes: RouteObject[] = [
  {
    index: true,
    element: <Navigate to="home" replace />,
  },
  {
    path: 'home',
    children: [
      { index: true, element: <CheckinListPage /> },
      { path: ':date', element: <CheckinListPage /> },
    ],
  },
  {
    path: 'checkin/remarks/:visitId',
    element: <CheckinRemarksPage />,
  },
  {
    path: '*',
    element: <Navigate to="." replace />,
  },
];
